// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input-label[data-v-1e833828] {\n  display: inline-block;\n  width: 60px;\n  color: #666666;\n}\n.car-form-detail-form .lable-blue[data-v-1e833828]  .el-form-item__label {\n  color: blue !important;\n}\n.car-form-detail-form .el-form-item[data-v-1e833828] {\n  margin-left: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
